// 有趣网站数据 - 视频平台和社交媒体
const interestingData = [
  // 视频平台
  {
    id: 1,
    name: "抖音",
    category: "视频平台",
    icon: "🎵",
    url: "https://www.douyin.com/",
    description: "抖音 - 记录美好生活",
    color: "#000000"
  },
  {
    id: 2,
    name: "Bilibili",
    category: "视频平台",
    icon: "📺",
    url: "https://www.bilibili.com/",
    description: "B站 - 哔哩哔哩干杯，年轻人喜爱的文化社区",
    color: "#FB7299"
  },
  {
    id: 3,
    name: "优酷视频",
    category: "视频平台",
    icon: "🎬",
    url: "https://www.youku.com/",
    description: "优酷 - 这世界很酷，阿里巴巴旗下视频平台",
    color: "#00B06C"
  },
  {
    id: 4,
    name: "腾讯视频",
    category: "视频平台",
    icon: "📹",
    url: "https://v.qq.com/",
    description: "腾讯视频 - 不负好时光，热门影视综艺独家播出",
    color: "#3196FA"
  },
  {
    id: 5,
    name: "爱奇艺",
    category: "视频平台",
    icon: "🎥",
    url: "https://www.iqiyi.com/",
    description: "爱奇艺 - 悦享品质，百度旗下视频平台",
    color: "#00BE06"
  },
  {
    id: 6,
    name: "芒果TV",
    category: "视频平台",
    icon: "🥭",
    url: "https://www.mgtv.com/",
    description: "芒果TV - 看见好时光，湖南卫视旗下视频平台",
    color: "#FF7200"
  },
  {
    id: 7,
    name: "AcFun",
    category: "视频平台",
    icon: "🔶",
    url: "https://www.acfun.cn/",
    description: "AcFun - 认真你就输啦，中国第一家弹幕视频网站",
    color: "#FD4C5D"
  },
  
  // 社交媒体
  {
    id: 8,
    name: "知乎",
    category: "社交媒体",
    icon: "💡",
    url: "https://www.zhihu.com/",
    description: "知乎 - 有问题，就会有答案",
    color: "#0084FF"
  },
  {
    id: 9,
    name: "微博",
    category: "社交媒体",
    icon: "🐦",
    url: "https://weibo.com/",
    description: "微博 - 随时随地发现新鲜事",
    color: "#E6162D"
  },
  {
    id: 10,
    name: "小红书",
    category: "社交媒体",
    icon: "📕",
    url: "https://www.xiaohongshu.com/",
    description: "小红书 - 标记我的生活",
    color: "#FF2442"
  },
  {
    id: 11,
    name: "豆瓣",
    category: "社交媒体",
    icon: "📚",
    url: "https://www.douban.com/",
    description: "豆瓣 - 书影音记录与分享社区",
    color: "#007722"
  },
  
  // 音乐平台
  {
    id: 12,
    name: "网易云音乐",
    category: "音乐平台",
    icon: "☁️",
    url: "https://music.163.com/",
    description: "网易云音乐 - 音乐的力量，个性化推荐",
    color: "#E60026"
  },
  {
      id: 13,
      name: "QQ音乐",
      category: "音乐平台",
      icon: "🎵",
      url: "https://y.qq.com/",
      description: "QQ音乐 - 音乐你的生活，海量正版曲库",
      color: "#31C27C"
    },
    
    // 热门视频
    {
      id: 14,
      name: "3台高速机VS刘谦手速！谁更胜一筹？",
      category: "热门视频",
      icon: "🎬",
      url: "https://www.bilibili.com/video/BV1XY546vE1o",
      description: "影视飓风 - 全站排行榜最高第1名，播放量562.4万",
      color: "#FB7299",
      cover: "images/001.jpg"
    },
    {
      id: 15,
      name: "中美会面前，双方如何出招？",
      category: "热门视频",
      icon: "🎬",
      url: "https://www.bilibili.com/video/BV1fs5b6UE4z",
      description: "小王Albert - 播放量305万",
      color: "#00AEEC",
      cover: "images/002.jpg"
    },
    {
      id: 16,
      name: "【NMIXX】\"Heavy Serenade\" M/V",
      category: "热门视频",
      icon: "🎬",
      url: "https://www.bilibili.com/video/BV1SY5s6oEpw",
      description: "NMIXX - 播放量112.5万",
      color: "#FF9900",
      cover: "images/003.jpg"
    },
    {
      id: 17,
      name: "数学家老田，已上线！！",
      category: "热门视频",
      icon: "🎬",
      url: "https://www.bilibili.com/video/BV1Rm5N61Epp",
      description: "田一名sir - 播放量362.1万",
      color: "#FF6B6B",
      cover: "images/004.jpg"
    },
    {
      id: 18,
      name: "色彩原理调色教程",
      category: "热门视频",
      icon: "🎬",
      url: "https://www.bilibili.com/video/BV1Z35n6xErz",
      description: "七芊摄影 - 播放量223.3万",
      color: "#9B59B6",
      cover: "images/005.jpg"
    }
  ];

export function getAllInterestingSites() {
  return interestingData;
}

export function getInterestingCategories() {
  var categorySet = {};
  var categories = [];
  for (var i = 0; i < interestingData.length; i++) {
    var category = interestingData[i].category;
    if (!categorySet[category]) {
      categorySet[category] = true;
      categories.push(category);
    }
  }
  return categories;
}

export function getInterestingByCategory(category) {
  return interestingData.filter(function(item) {
    return item.category === category;
  });
}

export { interestingData as sitesData };
